import './CoralListOverview.scss'

import { mapCoralWebListOverview } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { GraduateIcon } from '../../../coral-library/icons/Graduate.icon'
import { PresentationIcon } from '../../../coral-library/icons/Presentation.icon'
import { StarIcon } from '../../../coral-library/icons/Star.icon'

type CoralListOverviewProps = ReturnType<typeof mapCoralWebListOverview>

export const CoralListOverview: FC<CoralListOverviewProps> = ({ list }) => {
  return (
    <div className={'coral-list-overview-container'}>
      {list.map((item, index) => {
        return (
          <div className={'coral-list-overview__item'} key={index}>
            {index === 0 && <GraduateIcon className={'coral-list-overview__icon'} />}
            {index === 1 && <StarIcon className={'coral-list-overview__icon'} />}
            {index === 2 && <PresentationIcon className={'coral-list-overview__icon'} />}
            <p className={'coral-list-overview__label'}>{item.label}</p>
          </div>
        )
      })}
    </div>
  )
}
